import type { FC } from 'react';

import FreeCover from '../../assets/free-cover.svg';

import * as Styled from './cover-media.styles';

type CoverMediaProps = {
  coverImageSrc?: string;
};
export const CoverMedia: FC<CoverMediaProps> = ({ coverImageSrc }) => {
  return (
    <Styled.CoverImageWrapper $noImage={!coverImageSrc}>
      <Styled.CoverImageInner>
        <Styled.CoverOverlay />
        <Styled.CoverImage src={coverImageSrc ?? FreeCover} alt="Cover Image" />
      </Styled.CoverImageInner>
    </Styled.CoverImageWrapper>
  );
};
